// import React from "react";
// import { useState } from "react";
// import { useRef } from "react";
// import { verify_otp } from "../services/web/webServices";
// import { Store } from "react-notifications-component";
// import { useLocation, useNavigate } from "react-router-dom";

// function Otppage() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const email = location.state;

//   const [getButton, setButton] = useState(true);

//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const otpInputs = useRef([]);

//   const handleInputChange = (index, event) => {
//     const value = event.target.value;

//     // Ensure only numbers are entered and limit to 1 character
//     if (/^[0-9]*$/.test(value) && value.length <= 1) {
//       const newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);

//       // Move to the next input field if available
//       if (index < otp.length - 1 && value.length === 1) {
//         otpInputs.current[index + 1].focus();
//       }
//     }
//   };
//   const handleKeyDown = (index, event) => {
//     // Move to the previous input field on backspace
//     if (event.key === "Backspace" && index > 0 && otp[index] === "") {
//       otpInputs.current[index - 1].focus();
//     }
//   };

//   const handleOTPSubmit = () => {
//     const otpValue = otp.join("");
//     if (otpValue.length < otp.length) {
//       // Check if OTP is complete
//       Store.addNotification({
//         title: "Error!",
//         message: "Please enter OTP",
//         type: "danger",
//         insert: "top",
//         container: "top-right",
//         animationIn: ["animate__animated", "animate__fadeIn"],
//         animationOut: ["animate__animated", "animate__fadeOut"],
//         dismiss: {
//           duration: 3000,
//           onScreen: true,
//         },
//       });
//       return; // Prevent further execution
//     }
//     setButton(false);
//     verify_otp({ otp: otpValue, email: email })
//       .then((res) => {
//         setButton(true);
//         const passwordResetToken = res?.data?.passwordResetToken;
//         Store.addNotification({
//           title: "Success",
//           message: res?.data?.message,
//           type: "success",
//           insert: "top",
//           container: "top-right",
//           animationIn: ["animate__animated", "animate__fadeIn"],
//           animationOut: ["animate__animated", "animate__fadeOut"],
//           dismiss: {
//             duration: 3000,
//             onScreen: true,
//           },
//         });

//         navigate("/resetPassword", {
//           state: {
//             email: email,
//             passwordResetToken: passwordResetToken,
//           },
//         });
//       })
//       .catch((err) => {
//         setButton(true);
//         if (err) {
//           Store.addNotification({
//             title: "Error!",
//             message: err?.response?.data?.message,
//             type: "danger",
//             insert: "top",
//             container: "top-right",
//             animationIn: ["animate__animated", "animate__fadeIn"],
//             animationOut: ["animate__animated", "animate__fadeOut"],
//             dismiss: {
//               duration: 3000,
//               onScreen: true,
//             },
//           });

//           setButton(true);
//         }
//       });
//   };

//   const css = `
       

// .otp-container {
//   max-width: 400px;
//   margin: auto;
//   padding: 20px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//   background-color: #fff;
//   text-align: center;
//   background-color: #263043
// }

// h2 {
//   margin-bottom: 20px;
// }

// .otp-inputs {
//   display: flex;
//   justify-content: center;
// }

// .otp-inputs input {
//   width: 50px;
//   height: 50px;
//   margin: 0 5px;
//   text-align: center;
//   font-size: 24px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   outline: none;
   
// }
// button {
//   padding: 12px;
//   background-color: #076A33;
//   margin:15px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 16px;
// }

// button:hover {
//   background-color: #076A33;
// }
// .resend-otp {
//   margin-top: 20px;
// }

// .resend-otp button {
//   background: none;
//   border: none;
//   color: #007bff;
//   cursor: pointer;
//   font-size: 14px;
//   text-decoration: underline;
// }

//   `;

//   return (
//     <>
//       <style>{css}</style>
//       <div
//         style={{
//           backgroundImage: `url(/images/image1.png)`,
//           height: "100vh",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           paddingTop: "150px",
//         }}
//       >
//         <div className="otp-container">
//           <img
//             src="/images/logo.png"
//             alt="logo"
//             style={{ margin: "30px", marginLeft: "40px" }}
//           />
//           <h2>Enter OTP</h2>
//           <div className="otp-inputs">
//             {otp.map((digit, index) => (
//               <input
//                 key={index}
//                 type="text"
//                 maxLength="1"
//                 value={digit}
//                 onChange={(e) => handleInputChange(index, e)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 ref={(input) => (otpInputs.current[index] = input)}
//                 autoFocus={index === 0 ? true : false}
//               />
//             ))}
//           </div>

//           <button
//             type="button"
//             onClick={handleOTPSubmit}
//             disabled={!getButton}
//             style={{ fontSize: "20px", color: "#fff" }}
//           >
//             {getButton ? "Submit" : "Please wait..."}
//           </button>
//           {/* <p className="resend-otp">
//             Didn't receive OTP? <button>Resend OTP</button>
//           </p> */}
//         </div>
//       </div>
//     </>
//   );
// }

// export default Otppage;

import React, { useState, useRef } from "react";
import { verify_otp } from "../services/web/webServices";
import { Store } from "react-notifications-component";
import { useLocation, useNavigate } from "react-router-dom";

function Otppage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state;

  const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);

  const otpInputs = useRef([]);

  // Store the notification id to remove it later if necessary
  const notificationIdRef = useRef(null);

  const handleInputChange = (index, event) => {
    const value = event.target.value;

    // Ensure only numbers are entered and limit to 1 character
    if (/^[0-9]*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input field if available
      if (index < otp.length - 1 && value.length === 1) {
        otpInputs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, event) => {
    // Move to the previous input field on backspace
    if (event.key === "Backspace" && index > 0 && otp[index] === "") {
      otpInputs.current[index - 1].focus();
    }
  };

  const showNotification = (title, message, type) => {
    // Remove previous notification if it exists
    if (notificationIdRef.current) {
      Store.removeNotification(notificationIdRef.current);
    }

    // Add new notification
    notificationIdRef.current = Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true,
      },
    });
  };

  const handleOTPSubmit = () => {
    const otpValue = otp.join("");
    if (otpValue.length < otp.length) {
      // Always show notification if OTP is incomplete
      showNotification("Error!", "Please enter OTP", "danger");
      return; // Prevent further execution
    }

    setSubmitButtonDisabled(true); // Disable the button when submitting

    verify_otp({ otp: otpValue, email: email })
      .then((res) => {
        setSubmitButtonDisabled(false); // Enable the button after response
        const passwordResetToken = res?.data?.passwordResetToken;
        showNotification("Success", res?.data?.message, "success");

        navigate("/resetPassword", {
          state: {
            email: email,
            passwordResetToken: passwordResetToken,
          },
        });
      })
      .catch((err) => {
        setSubmitButtonDisabled(false); // Enable the button after error
        if (err) {
          showNotification("Error!", err?.response?.data?.message, "danger");
        }
      });
  };

  const css = `
    .otp-container {
      max-width: 400px;
      margin: auto;
      padding: 20px;
      border: 1px solid #ccc;
      border-radius: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      text-align: center;
      background-color: #263043;
    }

    h2 {
      margin-bottom: 20px;
    }

    .otp-inputs {
      display: flex;
      justify-content: center;
    }

    .otp-inputs input {
      width: 50px;
      height: 50px;
      margin: 0 5px;
      text-align: center;
      font-size: 24px;
      border: 1px solid #ccc;
      border-radius: 5px;
      outline: none;
    }

    button {
      padding: 12px;
      background-color: #076A33;
      margin: 15px;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
    }

    button:hover {
      background-color: #055A24;
    }

    .resend-otp {
      margin-top: 20px;
    }

    .resend-otp button {
      background: none;
      border: none;
      color: #007bff;
      cursor: pointer;
      font-size: 14px;
      text-decoration: underline;
    }
  `;

  return (
    <>
      <style>{css}</style>
      <div
        style={{
          backgroundImage: `url(/images/image1.png)`,
          height: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "150px",
        }}
      >
        <div className="otp-container">
          <img
            src="/images/logo.png"
            alt="logo"
            style={{ margin: "30px", marginLeft: "40px" }}
          />
          <h2>Enter OTP</h2>
          <div className="otp-inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleInputChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(input) => (otpInputs.current[index] = input)}
                autoFocus={index === 0}
              />
            ))}
          </div>
          <button
            type="button"
            onClick={handleOTPSubmit}
            disabled={isSubmitButtonDisabled}
            style={{ fontSize: "20px", color: "#fff" }}
          >
            {isSubmitButtonDisabled ? "Please wait..." : "Submit"}
          </button>
          {/* <p className="resend-otp">
            Didn't receive OTP? <button>Resend OTP</button>
          </p> */}
        </div>
      </div>
    </>
  );
}

export default Otppage;
